module.exports = __webpack_public_path__ + "img/rocha-e-medeiros.3da1b687.jpg";